module.exports = __webpack_public_path__ + "static/am-ende-der-hoffnuglosigkeit-01-99d0d5b65bded77f93fbc1cfbdf56e94.jpg";